export const IDLESTATUS_WARNING = 'INACTIVE';

export const IDLE_STATUSES = [IDLESTATUS_WARNING];

export const HOURS_FOR_INACTIVITY = 0.5; // User is warned after 30 min of inactivity
export const OPERATOR_HOURS_FOR_INACTIVITY = 5; // FOR Pass Operator role and no one else
